import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('CustomSelectOptionSecondaryText', null, {
    withChildren: true,
});
